import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import { Detector } from "react-detect-offline";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { initializeApp } from "firebase/app";
import { useSelector } from "react-redux";
import { isEmpty, isObject } from "lodash";
import { useMediaQuery, useTheme } from "@mui/material";
import Signup from "./pages/Signup";
import CreateProfile from "./pages/CreateProfile";
import ResetPassword from "./pages/ResetPassword";
import OtpInput from "./pages/OtpInput";
import PhoneVerify from "./pages/PhoneVerify";
import Footer from "./components/Footer";
import NotificationPopup from "./components/NotificationPopUp";
import "./App.css";
import ContractorProfile from "./pages/ContractorProfile";
import AccountSettings from "./pages/AccountSettings";
import Billing from "./pages/Billing";
import UserManagement from "./pages/UserManagement";
import HomeownerTermsAndConditions from "./pages/HomeownerTermsAndConditions";
import ContractorDocuments from "./pages/ContractorDocuments";
import DesignerDocuments from "./pages/DesignerDocuments";
import Payments from "./pages/Payments";
import Packages from "./pages/Packages";
import Proposals from "./pages/Proposals";
import Projects from "./pages/Projects";
import DrawerComponent from "./components/Drawer";
import ProjectBalance from "./pages/ProjectBalance";
import NewProjectDetails from "./pages/NewProjectDetails";
import MilestoneDetails from "./pages/NewProjectDetails/components/Milestones/MilestoneDetails";
import ProjectUpdateDetailsPage from "./pages/NewProjectDetails/components/ProjectUpdates/ProjectUpdateDetailsPage";
import NewProposalDetails from "./pages/NewProposalDetails";
import NewCreateProposal from "./pages/NewCreateProposal";
import ProposalMilestoneDetails from "./pages/NewCreateProposal/components/Milestones/components/ProposalMilestoneDetails";
import NewPackageDetails from "./pages/NewPackageDetails";
import InclusionDetails from "./pages/NewPackageDetails/components/Inclusions/InclusionDetails";
import NewCreatePackage from "./pages/NewCreatePackage";
import PackageInclusionDetails from "./pages/NewCreatePackage/components/Inclusions/components/PackageInclusionDetails";
import SupplierDocuments from "./pages/SupplierDocuments";
import NewLogin from "./pages/NewLogin";
import HomeScreen from "./pages/HomeScreen";
import ForgotPassword from "./pages/ForgotPassword";
import RoleSelection from "./pages/RoleSelection";
import MilestoneSnagDetails from "./pages/NewProjectDetails/components/Inspections/MilestoneSnagDetails";
import EditProfileForm from "./pages/EditProfileForm";
import SetupAccount from "./pages/SetupAccount";
import ProtectedRoute from "./components/ProtectedRoute";
import Conversation from "./pages/Conversation";

const firebaseConfig = {
  apiKey: "AIzaSyDeJrr2C4h4tIh7Hj0L4-qa1QwRBTfyHXM",
  authDomain: "reno-home.firebaseapp.com",
  projectId: "reno-home",
  storageBucket: "reno-home.appspot.com",
  messagingSenderId: "271291217173",
  appId: "1:271291217173:web:7a4260dcb3527e5869651c",
  measurementId: "G-FL6WQC501W",
};

function App() {
  initializeApp(firebaseConfig);
  const { userData } = useSelector((state) => state.auth);
  const [isLogin, setIsLogin] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    if (isObject(userData) && !isEmpty(userData)) {
      setIsLogin(true);
    } else {
      setIsLogin(false);
    }
  }, [userData]);

  {console.log("env", process.env.REACT_APP_LOCALE)}

  return (
    <Detector
      interval={10000}
      render={({ online }) => {
        return (
          <Router>
            <Routes>
              <Route
                path="/homeowner-terms-and-conditions"
                element={<HomeownerTermsAndConditions />}
              />
               <Route
                        path={"/account-password"}
                        element={<SetupAccount />}
                      />
              <Route
                path="/"
                element={
                  <div
                    style={{
                      display: "flex",
                      height: "100vh",
                      boxSizing: "border-box",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        overflow: "hidden",
                      }}
                    >
                      <DrawerComponent />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          flex: 1,
                          height: "100vh",
                          overflowY: "auto",
                          paddingTop: isMobile ? "55px" : "0"
                        }}
                        className={isMobile ? "main-content-area" : ""}
                      >
                        <Outlet />
                      </div>
                    </div>
                    <Footer />
                  </div>
                }
              >
                {isLogin ? (
                  <>
                    <Route path={"/otp-verify"} element={<OtpInput />} />
                    <Route
                      path={"/create-profile"}
                      element={<CreateProfile />}
                    />
                    {/* Projects routes - Protected with PROJECTS READ permission */}
                    <Route
                      path={"/dashboard"}
                      element={
                        <ProtectedRoute resource="PROJECTS" action="READ">
                          <Projects />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/new-create-proposal/:id?/:tab?"
                      element={
                        <ProtectedRoute resource="PROJECTS" action="READ">
                          <NewCreateProposal />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path={"/new-create-proposal/:id/milestone/:milestoneId"}
                      element={
                        <ProtectedRoute resource="PROJECTS" action="READ">
                          <ProposalMilestoneDetails />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path={"/project/details/:id/milestone/:milestoneId"}
                      element={
                        <ProtectedRoute resource="PROJECTS" action="READ">
                          <MilestoneDetails />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path={"/project/details/:id/project-updates/details"}
                      element={
                        <ProtectedRoute resource="PROJECTS" action="READ">
                          <ProjectUpdateDetailsPage />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path={"/project/details/:id/snag/:visitId"}
                      element={
                        <ProtectedRoute resource="PROJECTS" action="READ">
                          <MilestoneSnagDetails />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path={"/project/details/:id/:tab?/:subTab?"}
                      element={
                        <ProtectedRoute resource="PROJECTS" action="READ">
                          <NewProjectDetails />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path={"/proposal/details/:id/:tab?"}
                      element={
                        <ProtectedRoute resource="PROJECTS" action="READ">
                          <NewProposalDetails />
                        </ProtectedRoute>
                      }
                    />
                    {/* Package detail routes - Protected with PACKAGES READ permission */}
                    <Route
                      path={"/package/details/:id/inclusion/:inclusionId"}
                      element={
                        <ProtectedRoute resource="PACKAGES" action="READ">
                          <InclusionDetails />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path={"/package/details/:id/:tab?"}
                      element={
                        <ProtectedRoute resource="PACKAGES" action="READ">
                          <NewPackageDetails />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/new-create-package/:id?/:tab?"
                      element={
                        <ProtectedRoute resource="PACKAGES" action="READ">
                          <NewCreatePackage />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path={"/new-create-package/:id/inclusion/:milestoneId"}
                      element={
                        <ProtectedRoute resource="PACKAGES" action="READ">
                          <PackageInclusionDetails />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path={"/contractor-profile"}
                      element={<ContractorProfile />}
                    />
                    <Route
                      path={"/account-setting"}
                      element={
                        <ProtectedRoute resource="PROFILE" action="READ">
                          <AccountSettings />
                        </ProtectedRoute>
                      }
                    />
                    <Route path={"/conversation"} element={<Conversation />} />
                    <Route
                      path={"/edit-profile-form"}
                      element={<EditProfileForm />}
                    />
                    <Route
                      path={"/account-setting/users"}
                      element={
                        <ProtectedRoute resource="USERS" action="READ">
                          <UserManagement />
                        </ProtectedRoute>
                      }
                    />
                    <Route path={"/billing"} element={<Billing />} />
                    {/* <Route
                        path={"/create-proposal"}
                        element={<CreateProposal />}
                      />
                      <Route path={"/ongoing-project"} element={<OnGoing />} />
                      <Route
                        path={"/request-proposal"}
                        element={<RequestedProposal />}
                      /> */}
                    {/* Finance routes - Protected with payment-related permissions */}
                    <Route
                      path={"/balance-breakdown"}
                      element={
                        <ProtectedRoute resource="CONTRACTOR_PAYOUTS" action="READ">
                          <ProjectBalance />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path={"/payments"}
                      element={
                        <ProtectedRoute resource="CUSTOMER_PAYMENTS" action="READ">
                          <Payments />
                        </ProtectedRoute>
                      }
                    />
                    {/* Packages route - Protected with PACKAGES READ permission */}
                    <Route
                      path={"/packages"}
                      element={
                        <ProtectedRoute resource="PACKAGES" action="READ">
                          <Packages />
                        </ProtectedRoute>
                      }
                    />
                    {/* Proposals route - Protected with PROJECTS READ permission */}
                    <Route
                      path={"/proposals"}
                      element={
                        <ProtectedRoute resource="PROJECTS" action="READ">
                          <Proposals />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path={"/contractor-documents"}
                      element={<ContractorDocuments />}
                    />
                    <Route
                      path={"/designer-documents"}
                      element={<DesignerDocuments />}
                    />
                    <Route
                      path={"/supplier-documents"}
                      element={<SupplierDocuments />}
                    />
                    <Route
                      path={"/user-management"}
                      element={<UserManagement />}
                    />
                    <Route path={"/role"} element={<RoleSelection />} />
                    <Route
                      index
                      element={
                        <Navigate
                          to={
                            (() => {
                              // Check if user has a non-standard role (doesn't require profile creation)
                              const standardRoles = ["designer", "contractor", "supplier"];
                              const isNonStandardRole = userData?.role && !standardRoles.includes(userData?.role);
                              
                              // Non-standard roles skip profile creation even if pending
                              if (
                                !isNonStandardRole &&
                                userData?.contractor_data &&
                                userData?.contractor_data?.profile_completed === "pending"
                              ) {
                                return "/create-profile";
                              }
                              return "/dashboard";
                            })()
                          }
                        />
                      }
                      replace
                    />
                    <Route
                      path="*"
                      element={
                        <Navigate
                          to={
                            (() => {
                              // Check if user has a non-standard role (doesn't require profile creation)
                              const standardRoles = ["designer", "contractor", "supplier"];
                              const isNonStandardRole = userData?.role && !standardRoles.includes(userData?.role);
                              
                              // Non-standard roles skip profile creation even if pending
                              if (
                                !isNonStandardRole &&
                                userData?.contractor_data &&
                                userData?.contractor_data?.profile_completed === "pending"
                              ) {
                                return "/create-profile";
                              }
                              return "/dashboard";
                            })()
                          }
                        />
                      }
                    />{" "}
                  </>
                ) : (
                  <>
                    <>
                      <Route
                        index
                        element={<Navigate to="/login" replace />}
                      />
                      <Route path={"/login"} element={<HomeScreen />} />
                      <Route path={"/user-login"} element={<NewLogin />} />

                      <Route path={"/signup"} element={<Signup />} />
                      <Route
                        path={"/reset-password"}
                        element={<ResetPassword />}
                      />
                      <Route
                        path={"/forgot-password"}
                        element={<ForgotPassword />}
                      />
                     
                      <Route path={"/otp-verify"} element={<OtpInput />} />
                      <Route
                        path={"/phone-verify"}
                        element={<PhoneVerify />}
                      />

                      <Route path={"/role"} element={<RoleSelection />} />
                      <Route path="*" element={<Navigate to={"/"} />} />
                    </>
                  </>
                )}
              </Route>
            </Routes>
            <NotificationPopup />
            <ToastContainer
              autoClose={3000}
              pauseOnFocusLoss={false}
              toastClassName="toastStyle"
            />
          </Router>
        );
      }}
    />
  );
}

export default App;
